import Typography from '@mui/material/Typography';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useForm } from 'react-final-form';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import useJumpBackAndResetDeposit from '../../../hooks/useJumpBackAndResetDeposit';
import Prompt from '../../Prompt/Prompt';

import {
  TXTWCL_Choose_another_payment_method,
  TXTWCL_Just_a_heads_up,
  TXTWCL_This_deposit_will_likely_fail__ELL,
  TXTWCL_Try_again,
  TXTWCL_Your_recent_deposit_request_fa_ELL
} from './RepeatedDecline.messages.json';

interface Props {
  onClose(): void;
}

const RepeatedDecline: React.FC<Props> = ({ onClose }) => {
  const form = useForm();
  const jumpBackAndResetDeposit = useJumpBackAndResetDeposit();
  const {
    data,
    values: { deposit }
  } = useWizardContext();

  const { previousDeposit } = data;
  const repeatedCashinDeclineOptions = previousDeposit?.repeatedCashinDeclineOptions;

  const closePrompt = () => {
    onClose();
    data.previousDeposit = null;
  };

  const hasRepeatedDeclineOption = repeatedCashinDeclineOptions?.includes(
    'eRepeatedCashinDeclineOptionDepositNow'
  );

  const handleContinue = () => {
    closePrompt();
    deposit.ignorePreviousDeclines = true;
    form.submit();
  };

  const handleChooseAnotherMethod = () => {
    closePrompt();
    jumpBackAndResetDeposit('#deposit.deposit-method');
  };

  return (
    <Prompt
      variant="warning"
      title={{
        translation: TXTWCL_Just_a_heads_up
      }}
      primaryButton={{
        translation: hasRepeatedDeclineOption
          ? TXTWCL_Try_again
          : TXTWCL_Choose_another_payment_method
      }}
      onPrimaryButtonClick={hasRepeatedDeclineOption ? handleContinue : handleChooseAnotherMethod}
      onClose={closePrompt}
      {...(hasRepeatedDeclineOption && {
        secondaryButton: { translation: TXTWCL_Choose_another_payment_method },
        onSecondaryButtonClick: handleChooseAnotherMethod
      })}
    >
      <Typography>
        <Translation {...TXTWCL_Your_recent_deposit_request_fa_ELL} />{' '}
        <Translation {...TXTWCL_This_deposit_will_likely_fail__ELL} />
      </Typography>
    </Prompt>
  );
};

export default RepeatedDecline;
